import * as React from 'react';
import DesignPreferencePageView from '../layouts/DesignPreferencePageView';
import { BranchData } from 'src/reducers/fileUpload';

export interface DesignPreferencePageViewProps {
  onComponentDidMount: () => void;
  orderDataBranch: BranchData[];
  goEditDesignPreference: (sbu: string) => void;
}

class DesignPreferencePage extends React.Component<DesignPreferencePageViewProps> {
  render() {
    return (
      <div>
        <DesignPreferencePageView
          orderDataBranch={this.props.orderDataBranch}
          goEditDesignPreference={this.props.goEditDesignPreference}
        />
      </div>
    );
  }
  componentDidMount() {
    this.props.onComponentDidMount();
  }
}

export default DesignPreferencePage;



// WEBPACK FOOTER //
// ./src/components/designPreferences/DesignPreferencePage.tsx